import { Mutator } from 'final-form'
import { MetaPath } from 'util/metaPath'

const updateValue: Mutator<any> = ([name, value]: [MetaPath<any>, any], state, { changeValue }) => {
  changeValue(state, name.absolutePath(), () => value)
}

export default updateValue
